import { render, staticRenderFns } from "./Tab3.vue?vue&type=template&id=10899633&scoped=true&"
import script from "./Tab3.vue?vue&type=script&lang=js&"
export * from "./Tab3.vue?vue&type=script&lang=js&"
import style0 from "./Tab3.vue?vue&type=style&index=0&id=10899633&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10899633",
  null
  
)

export default component.exports